import { useMutation, useQueryClient } from '@tanstack/react-query';

import { POADocumentType } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface SendDocumentProps {
  importerId: string;
  type: POADocumentType;
}

export const useSendDocument = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ importerId, type }: SendDocumentProps) => {
      const sendFn = type === POADocumentType.POA ? apiClient.importer.sendPoa.mutation : apiClient.importer.sendVat.mutation;
      const result = await sendFn({ params: { id: importerId } });
      if (result.status !== 200) throw result.body;
      return result.body;
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['importer', variables.importerId] });
    },
    onError: (error) => {
      showErrorToast(error, `Error sending document!`);
    },
  });
};
